import update from "immutability-helper";
import { AppReduxActions } from "./Action";
import { IProfile } from "states/authentication/Reducer";

export interface IBranch {
  branchId: string;
  companyId: string;
  shopName: string;
  shopAddress: string;
  city: string;
  phoneNumber: string;
  email: string;
  gstNo: string;
  showGstNo: string;
  welcomeNote: string;
  printerIp: string;
  printerPort: string;
  printerFormat: "A4" | "Receipt";
}
export interface IAppConfigState {
  branch: IBranch;
  printerStatus: "Connected" | "Pending";
  employees: IProfile[];
}

const appConfig: IAppConfigState = {
  branch: {
    branchId: "",
    companyId: "",
    shopName: "",
    shopAddress: "",
    city: "",
    phoneNumber: "",
    email: "",
    gstNo: "",
    showGstNo: "0",
    welcomeNote: "Thanks for doing business with us!",
    printerIp: "",
    printerPort: "",
    printerFormat: "A4",
  },
  printerStatus: "Pending",
  employees: [],
};

const AppConfigReducer = (
  state = appConfig,
  action: any = { type: "", payload: {} }
): IAppConfigState => {
  switch (action.type) {
    case AppReduxActions.SAVE_CONFIG:
      return update(state, {
        $merge: {
          ...action.payload,
        },
      });
    case AppReduxActions.SAVE_EMPLOYEES:
      return update(state, {
        $merge: {
          employees: action.payload,
        },
      });
    default:
      return state;
  }
};

export default AppConfigReducer;
